import React, { useState } from 'react';
import styled, { withTheme } from 'styled-components';
import { Text, Button, Icon } from 'components/atoms';
import PropTypes from 'prop-types';
import { useSpring, animated } from 'react-spring';
import { themeType } from 'types'

const SectionCard = ({
  title,
  description,
  img,
  theme,
}) => {
  const [isHover, setHover] = useState(false);
  const animation = useSpring({
    opacity: isHover ? 1 : 0,
    display: isHover ? 'flex' : 'none',
  });
  return (
    <Section
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Section.Top>
        {img
          ? (
            <img src={img} alt="section thumbnail" />
          )
          : (
            <Section.NoImage>
              <Icon
                icon="section"
                height={69}
                color={theme.colors.bgLighter}
              />
            </Section.NoImage>
          )
        }
      </Section.Top>
      <Section.Bottom>
        <Text>{title}</Text>
        <Section.Active style={animation}>
          {description && (
            <Text modifiers={['light', 'small']}>{description}</Text>
          )}
          <Button modifiers={['primary', 'small', 'stretch']}>
            Add section
          </Button>
        </Section.Active>
      </Section.Bottom>
    </Section>
  );
};

SectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  img: PropTypes.string,
  theme: themeType.isRequired,
};

SectionCard.defaultProps = {
  description: null,
  img: null,
};

const Section = styled.div`
  width: ${props => props.theme.components.sectionCard.width};
  background-color: ${props => props.theme.colors.bgLighter};
  cursor: pointer;
  border: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.borderLighter};
  border-bottom-left-radius: ${props => props.theme.values.borderRadius};
  border-bottom-right-radius: ${props => props.theme.values.borderRadius};
  transition: transform 0.2s ease-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.04);
    box-shadow: ${props => props.theme.shadows.card};
  }
`;

Section.NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Section.Top = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.bgLighterS};
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
  }
`;

Section.Bottom = styled.div`
  background-color: ${props => props.theme.colors.bgLighter};
  padding: 8px;
  border-bottom-left-radius: ${props => props.theme.values.borderRadius};
  border-bottom-right-radius: ${props => props.theme.values.borderRadius};
  ${Text} {
    margin-bottom: ${props => props.theme.spacing.xs3};
  }
`;

Section.Active = styled(animated.div)`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ${Text} {
    margin-bottom: ${props => props.theme.spacing.xs2};
  }
  button {
    margin-bottom: 0;
  }
`;

export default withTheme(SectionCard);
